(() => {
  const boundAttribute = 'data-oix-header-bound';
  let activeHeaderPointerContainer = null;
  let headerPointerAttached = false;

  const bindOnce = (element, eventName, handler, key = eventName) => {
    if (!element) return;
    const attribute = `${boundAttribute}-${key}`;
    if (element.hasAttribute(attribute)) return;
    element.setAttribute(attribute, 'true');
    element.addEventListener(eventName, handler);
  };

  const getHeader = () => document.querySelector('.header');

  const closeSearch = () => {
    const header = getHeader();
    const searchDetails = document.querySelector('.header__details');
    if (searchDetails) searchDetails.removeAttribute('open');
    document.body.classList.remove('overflow-hidden', 'search-overflow-hidden');
    if (header) header.classList.remove('search-header--opened');
  };

  const syncSearchState = (searchDetails) => {
    if (!searchDetails) return;
    const header = getHeader();
    const isOpen = searchDetails.hasAttribute('open');
    document.body.classList.toggle('overflow-hidden', isOpen);
    document.body.classList.toggle('search-overflow-hidden', isOpen);
    if (header) header.classList.toggle('search-header--opened', isOpen);
    if (isOpen) {
      window.requestAnimationFrame(() => {
        const input = searchDetails.querySelector('input[type="search"]');
        if (input) input.focus({ preventScroll: true });
      });
    }
  };

  const closeOffcanvas = () => {
    const openButton = document.querySelector('.header__offcanvas-toggle');
    const closeButton = document.querySelector('.header__offcanvas-toggle-link--close');
    const offcanvasMenu = document.querySelector('.header__offcanvas-menu');
    const inlineMenu = document.querySelector('.header__inline-menu');

    if (offcanvasMenu) {
      offcanvasMenu.classList.remove('header__offcanvas-menu--open');
      offcanvasMenu.classList.add('header__offcanvas-menu--close');
      offcanvasMenu.setAttribute('aria-hidden', 'true');
    }
    if (openButton) {
      openButton.classList.remove('active');
      openButton.style.display = '';
      openButton.setAttribute('aria-expanded', 'false');
    }
    if (closeButton) closeButton.style.display = 'none';
    if (inlineMenu) inlineMenu.style.display = '';
    document.body.classList.remove('body--hidden');
  };

  const openOffcanvas = (event) => {
    const openButton = document.querySelector('.header__offcanvas-toggle');
    const closeButton = document.querySelector('.header__offcanvas-toggle-link--close');
    const offcanvasMenu = document.querySelector('.header__offcanvas-menu');
    const inlineMenu = document.querySelector('.header__inline-menu');

    if (!offcanvasMenu || !openButton) return;
    if (event) event.preventDefault();

    offcanvasMenu.classList.remove('header__offcanvas-menu--close');
    offcanvasMenu.classList.add('header__offcanvas-menu--open');
    offcanvasMenu.setAttribute('aria-hidden', 'false');
    openButton.classList.add('active');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('body--hidden');
    if (closeButton) closeButton.style.display = 'block';
    openButton.style.display = 'none';
    if (inlineMenu) inlineMenu.style.display = 'none';
  };

  const initializeSearchTabs = (root = document) => {
    const tabs = root.querySelectorAll?.('.predictive-search__result-tab') || [];
    const resultLists = document.querySelectorAll('.search__items-list');
    if (!tabs.length || !resultLists.length) return;

    if (!document.querySelector('.predictive-search__result-tab.active')) tabs[0].classList.add('active');
    if (!document.querySelector('.search__items-list.active')) resultLists[0].classList.add('active');

    tabs.forEach((tab) => {
      bindOnce(tab, 'click', (event) => {
        event.preventDefault();
        const targetType = tab.dataset.typeTarget;
        document.querySelectorAll('.predictive-search__result-tab').forEach((item) => {
          item.classList.toggle('active', item === tab);
          item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        });
        document.querySelectorAll('.search__items-list').forEach((list) => {
          list.classList.toggle('active', list.dataset.type === targetType);
        });
      }, 'search-tab');
    });
  };

  const initializeHeader = (root = document) => {
    const header = getHeader();
    if (!header) return;

    const openButton = document.querySelector('.header__offcanvas-toggle');
    const closeButton = document.querySelector('.header__offcanvas-toggle-link--close');
    const offcanvasMenu = document.querySelector('.header__offcanvas-menu');
    const inlineMenu = document.querySelector('.header__inline-menu');
    const searchDetails = document.querySelector('.header__details');
    const searchCloseButton = document.querySelector('.search-modal-close-button');

    if (offcanvasMenu && !offcanvasMenu.id) offcanvasMenu.id = 'OixOffcanvasMenu';
    if (openButton && offcanvasMenu) {
      openButton.setAttribute('aria-controls', offcanvasMenu.id);
      openButton.setAttribute('aria-expanded', offcanvasMenu.classList.contains('header__offcanvas-menu--open') ? 'true' : 'false');
      bindOnce(openButton, 'click', openOffcanvas, 'open-offcanvas');
    }
    if (closeButton) {
      bindOnce(closeButton, 'click', (event) => {
        event.preventDefault();
        closeOffcanvas();
      }, 'close-offcanvas');
    }
    if (offcanvasMenu) {
      offcanvasMenu.setAttribute('aria-hidden', offcanvasMenu.classList.contains('header__offcanvas-menu--open') ? 'false' : 'true');
    }
    if (inlineMenu) inlineMenu.removeAttribute('aria-hidden');

    if (searchDetails) bindOnce(searchDetails, 'toggle', () => syncSearchState(searchDetails), 'search-toggle');
    if (searchCloseButton) bindOnce(searchCloseButton, 'click', closeSearch, 'search-close');

    const submenuDetails = header.querySelectorAll('.header__submenu li details');
    submenuDetails.forEach((targetDetails) => {
      bindOnce(targetDetails, 'toggle', () => {
        if (!targetDetails.open) return;
        submenuDetails.forEach((details) => {
          if (details !== targetDetails) details.removeAttribute('open');
        });
      }, 'submenu-toggle');
    });

    initializeSearchTabs(root);
  };

  const updateOverlayHeader = () => {
    const header = getHeader();
    if (!header || !document.querySelector('.overlay')) return;
    header.classList.toggle('header_overlay-scroll', window.scrollY > 50);
  };

  const closeHeaderLayers = (event) => {
    if (event.key !== 'Escape') return;
    closeOffcanvas();
    closeSearch();
    document.querySelectorAll('.shopify-section-header details[open]').forEach((details) => details.removeAttribute('open'));
  };

  const followHeaderPointer = (event) => {
    if (!activeHeaderPointerContainer) return;
    const headerSection = document.querySelector('.shopify-section-header');
    const headerHeight = headerSection ? headerSection.offsetHeight : 0;
    activeHeaderPointerContainer.style.left = `${event.pageX}px`;
    activeHeaderPointerContainer.style.top = `${event.pageY - window.scrollY - headerHeight + 30}px`;
  };

  window.showTextHeader = () => {
    if (window.innerWidth <= 990) return;
    activeHeaderPointerContainer = document.querySelector('.shopify-section-header .button--with-underline--container');
    if (!activeHeaderPointerContainer || headerPointerAttached) return;
    headerPointerAttached = true;
    activeHeaderPointerContainer.style.display = 'block';
    document.addEventListener('pointermove', followHeaderPointer);
  };

  window.hideTextHeader = () => {
    if (activeHeaderPointerContainer) activeHeaderPointerContainer.style.display = '';
    activeHeaderPointerContainer = null;
    headerPointerAttached = false;
    document.removeEventListener('pointermove', followHeaderPointer);
  };

  document.addEventListener('DOMContentLoaded', () => {
    initializeHeader();
    updateOverlayHeader();
  });
  document.addEventListener('shopify:section:load', (event) => initializeHeader(event.target));
  document.addEventListener('keydown', closeHeaderLayers);
  window.addEventListener('scroll', updateOverlayHeader, { passive: true });

  initializeHeader();
  updateOverlayHeader();
})();
